
// Saunas whose models get their own links in the menu (a hover flyout on desktop,
// a tap-to-expand row on mobile). Keyed by the EBMS id /menu-products returns,
// not the slug, which changes whenever EBMS renames the product. Each `sku` is
// one of that product's offers: the link lands on /{slug}#{sku} and ProductPage
// preselects it from the fragment, as it does for a shared variant link.
const SAUNA_MODELS = {
  // CT Element Indoor Sauna
  "605003": [
    { name: "Nook (54x54)", sku: "606003" },
    { name: "Loft (54x74)", sku: "605003" },
    { name: "Studio (64x84)", sku: "604003" },
  ],
  // CT Barrel Saunas
  CTC22: [
    { name: "Harmony", sku: "CTC22" },
    { name: "Serenity", sku: "CTC2245" },
    { name: "Tranquility", sku: "CTC2345" },
  ],
  // CT Cabin Saunas
  CTC88: [
    { name: "Georgian", sku: "CTC88" },
    { name: "Palmer", sku: "CTC68" },
    { name: "Granby", sku: "CTC66" },
  ],
  // Pure Cube Neptune Sauna
  NE6112: [
    { name: "Neptune", sku: "NE6110" },
    { name: "Neptune Mini", sku: "NEMINC" },
  ],
};

const withModels = (product) => {
  const models = SAUNA_MODELS[String(product.id).trim()];
  return models ? { ...product, models } : product;
};

// The menu for CND / USA Online Only customers (__isOnlineOnlyUser). Their EBMS
// customer folder grants Canadian Timber (652) and some accessory folders, but
// none of the cross-brand roots in the default menu: All Saunas, Cold Plunges,
// Hot Tubs, Showers and Outdoor Furniture all 404 for them. So every link here
// is one of their folders, in the layout the client asked for.
// Chillers point at 438, not 668: only 438 is in their folder, and the two
// chillers 668 lists are 438 products linked in.
const ONLINE_ONLY_CATEGORIES = [
  {
    treeId: "  652",
    slug: "canadian-timber-collection",
    name: "Saunas",
    photo: "/images/navigation/saunas.jpg",
    staticSuperInventoryItems: [
      {
        treeId: "  652",
        slug: "canadian-timber-collection",
        name: "All Saunas",
        photo: "/images/navigation/saunas.jpg",
        private: false,
      },
      {
        treeId: "   76",
        slug: "canadian-timber-parts",
        name: "Sauna Parts",
        photo: "/images/navigation/sauna-parts.jpg",
        private: false,
      },
      {
        treeId: "  649",
        slug: "sauna-heaters",
        name: "Sauna Heaters",
        photo: "/images/navigation/sauna-heaters.jpg",
        private: false,
      },
    ],
  },
  {
    treeId: "  711",
    slug: "hot-tubs-cold-plunges-2",
    name: "Hot Tubs & Cold Plunges",
    photo: "/images/navigation/hot-tubs.jpg",
    staticSuperInventoryItems: [
      {
        treeId: "  711",
        slug: "hot-tubs-cold-plunges-2",
        name: "All Hot Tubs & Cold Plunges",
        photo: "/images/navigation/hot-tubs.jpg",
        private: false,
      },
      {
        treeId: "  670",
        slug: "hot-tub-accessories",
        name: "Hot Tub Accessories",
        photo: "/images/navigation/hot-tub-accessories.jpg",
        private: false,
      },
      {
        treeId: "  669",
        slug: "cold-plunge-accesories",
        name: "Cold Plunge Accessories",
        photo: "/images/navigation/cold-accessories.jpg",
        private: false,
      },
      {
        treeId: "  438",
        slug: "cold-plunge-chillers",
        name: "Cold Plunge Chillers",
        photo: "/images/navigation/cold-chillers.jpg",
        private: false,
      },
    ],
  },
  {
    treeId: "  712",
    slug: "outdoor-showers-2",
    name: "Outdoor Showers",
    photo: "/images/navigation/showers.jpg",
    staticSuperInventoryItems: [
      {
        treeId: "  712",
        slug: "outdoor-showers-2",
        name: "All Outdoor Showers",
        photo: "/images/navigation/showers.jpg",
        private: false,
      },
      {
        treeId: "  671",
        slug: "shower-accessories",
        name: "Shower Accessories",
        photo: "/images/navigation/shower-accessories.jpg",
        private: false,
      },
    ],
  },
  {
    treeId: "  719",
    slug: "outdoor-furniture-2",
    name: "Outdoor Furniture",
    scrollDropdown: true,
    photo: "/images/navigation/tiki-bars.jpg",
    staticSuperInventoryItems: [
      {
        treeId: "  719",
        slug: "outdoor-furniture-2",
        name: "All Outdoor Furniture",
        photo: "/images/navigation/tiki-bars.jpg",
        private: false,
      },
      {
        treeId: "  721",
        slug: "chairs-benches-1",
        name: "Chairs & Benches",
        photo: "/images/navigation/chairs-benches.jpg",
        private: false,
      },
      {
        treeId: "  722",
        slug: "outdoor-dining-1",
        name: "Outdoor Dining",
        photo: "/images/navigation/outdoor-dining.jpg",
        private: false,
      },
      {
        treeId: "  720",
        slug: "tiki-bars-stools",
        name: "Tiki Bars & Stools",
        photo: "/images/navigation/tiki-bars.jpg",
        private: false,
      },
    ],
  },
];

export default {
  data() {
    return {
      isLoading: true,
      isEmpty: false,
      // Read through the `categories` computed, which swaps in
      // ONLINE_ONLY_CATEGORIES for Online Only customers.
      defaultCategories: [
        {
          treeId: "  653",
          slug: "all-saunas",
          name: "Saunas",
          photo: "/images/navigation/saunas.jpg",
          // `column` pins the three-column layout Mehul asked for instead of
          // letting navigationContent chunk the list by staticItemsPerColumn:
          // the counts per column are uneven (3/2/2) and column 3 is the
          // logged-in-only one, so it has to stay a column even when the
          // Europe-only entries pad column 2.
          staticSuperInventoryItems: [
            {
              treeId: "  653",
              slug: "all-saunas",
              name: "All Saunas",
              photo: "/images/navigation/saunas.jpg",
              private: false,
              column: 1,
            },
            // Not EBMS categories — pages/outdoor-saunas.vue and
            // pages/indoor-saunas.vue split All Saunas on a hard-coded list
            // (utils/saunaCategories.js). getCategoryLink() uses `slug`, so no
            // treeId is needed or wanted here.
            {
              slug: "outdoor-saunas",
              name: "Outdoor Saunas",
              photo: "/images/navigation/saunas.jpg",
              private: false,
              column: 1,
            },
            {
              slug: "indoor-saunas",
              name: "Indoor Saunas",
              photo: "/images/navigation/saunas.jpg",
              private: false,
              column: 1,
            },
            {
              treeId: "  649",
              slug: "sauna-heaters",
              name: "Sauna Heaters",
              photo: "/images/navigation/sauna-heaters.jpg",
              private: false,
              column: 2,
            },
            {
              treeId: "  662",
              name: "Europe Only Electric Heaters",
              photo: "/images/navigation/sauna-heaters.jpg",
              private: false,
              europeOnly: true,
              column: 2,
            },
            {
              treeId: "  682",
              name: "Europe Only Wood Heaters",
              photo: "/images/navigation/sauna-heaters.jpg",
              private: false,
              europeOnly: true,
              column: 2,
            },
            {
              treeId: "  483",
              slug: "sauna-accessories",
              name: "Sauna Accessories",
              photo: "/images/navigation/sauna-accessories.jpg",
              private: false,
              column: 2,
            },
            {
              treeId: "  790",
              name: "Europe Only Accessories",
              photo: "/images/navigation/sauna-accessories.jpg",
              private: false,
              europeOnly: true,
              column: 2,
            },
            {
              treeId: "    3",
              slug: "parts-only",
              name: "Sauna Parts",
              photo: "/images/navigation/sauna-parts.jpg",
              private: true,
              column: 3,
            },
            {
              // EBMS still calls this category Store Promotional; the menu
              // label follows Mehul's mockup. Link target is unchanged.
              treeId: "  663",
              slug: "store-promotional",
              name: "Sauna Promotional",
              photo: "/images/navigation/store-promotional.jpg",
              private: true,
              column: 3,
            },
          ],
        },
        {
          treeId: "  654",
          slug: "cold-plunges",
          name: "Cold Plunges",
          photo: "/images/navigation/cold-plunges.jpg",
          staticSuperInventoryItems: [
            {
              treeId: "  654",
              slug: "cold-plunges",
              name: "All Cold Plunges",
              photo: "/images/navigation/cold-plunges.jpg",
              private: false,
            },
            {
              treeId: "  668",
              slug: "cold-plunge-chillers-1",
              name: "Cold Plunges Chillers",
              photo: "/images/navigation/cold-chillers.jpg",
              private: false,
            },
            {
              treeId: "  669",
              slug: "cold-plunge-accesories",
              name: "Cold Plunges Accessories",
              photo: "/images/navigation/cold-accessories.jpg",
              private: false,
            },
          ],
        },
        {
          treeId: "  659",
          slug: "hot-tubs",
          name: "Hot Tubs",
          photo: "/images/navigation/hot-tubs.jpg",
          staticSuperInventoryItems: [
            {
              treeId: "  659",
              slug: "hot-tubs",
              name: "All Hot Tubs",
              photo: "/images/navigation/hot-tubs.jpg",
              private: false,
            },
            {
              treeId: "  791",
              name: "Nordic Hot Tubs",
              photo: "/images/navigation/hot-tubs.jpg",
              private: false,
              europeOnly: true,
            },
            {
              treeId: "  670",
              slug: "hot-tub-accessories",
              name: "Hot Tubs Accessories",
              photo: "/images/navigation/hot-tub-accessories.jpg",
              private: false,
            },
          ],
        },
        {
          treeId: "  655",
          slug: "outdoor-showers-1",
          name: "Showers",
          photo: "/images/navigation/showers.jpg",
          staticSuperInventoryItems: [
            {
              treeId: "  655",
              slug: "outdoor-showers-1",
              name: "All Showers",
              photo: "/images/navigation/showers.jpg",
              private: false,
            },
            {
              treeId: "  671",
              slug: "shower-accessories",
              name: "Showers Accessories",
              photo: "/images/navigation/shower-accessories.jpg",
              private: false,
            },
          ],
        },
        {
          treeId: "  656",
          slug: "outdoor-furniture-1",
          name: "Outdoor Furniture",
          scrollDropdown: true,
          photo: "/images/navigation/tiki-bars.jpg",
          staticSuperInventoryItems: [
            {
              treeId: "  656",
              slug: "outdoor-furniture-1",
              name: "All Outdoor Furniture",
              photo: "/images/navigation/tiki-bars.jpg",
              private: false,
            },
            {
              treeId: "  672",
              slug: "tiki-bars",
              name: "Tiki Bars",
              photo: "/images/navigation/tiki-bars.jpg",
              private: false,
            },
            {
              treeId: "  673",
              slug: "chairs-benches",
              name: "Chairs & Benches",
              photo: "/images/navigation/chairs-benches.jpg",
              private: false,
            },
            {
              treeId: "  674",
              slug: "outdoor-dining",
              name: "Outdoor Dining",
              photo: "/images/navigation/outdoor-dining.jpg",
              private: false,
            },
          ],
        },
      ],
      activeCategory: null,
      superInventoryItems: [],
      saunaBrandGroups: [],
      saunaBrands: [
        {
          name: "Dundalk Saunas",
          treeId: "  650",
          slug: "dundalk-collection",
          exclude: ["  713", "  714"],
        },
        { name: "Pure Cube Saunas", treeId: "  651", slug: "pure-cube-collection" },
        {
          name: "Canadian Timber Saunas",
          treeId: "  652",
          slug: "canadian-timber-collection",
          includeLinked: false,
        },
      ],
      showContent: false,
      categoryCache: {},
      showMobileCategories: false,
      hoverTimeout: null,
      expandedModelsId: null,
    };
  },

  methods: {
    async getProducts(treeId) {
      const currentCategoryIndex = this.activeCategory;

      // Saunas tab (index 0) uses brand-grouped fetching
      if (currentCategoryIndex === 0) {
        return this.getSaunaProducts();
      }

      const staticItems = (
        this.categories[currentCategoryIndex]?.staticSuperInventoryItems || []
      ).filter((item) => !item.europeOnly || this.__isEuropeanUser);

      this.saunaBrandGroups = [];

      if (this.categoryCache[treeId]) {
        const cachedDynamicItems = this.categoryCache[treeId].filter(
          (item) => !item.hasOwnProperty("private"),
        );
        this.superInventoryItems = [...staticItems, ...cachedDynamicItems];
        this.isEmpty = !this.superInventoryItems.length;
        this.isLoading = false;
        return;
      }

      this.isLoading = true;

      try {
        const result = await this.$axios.$get("menu-products", {
          params: {
            treeId,
          },
        });

        const combinedItems = [...staticItems, ...result.products];

        this.categoryCache[treeId] = result.products;
        this.superInventoryItems = combinedItems;
      } catch (err) {
        this.__logError(err);

        this.categoryCache[treeId] = [];
        this.superInventoryItems = staticItems;
      }

      this.isEmpty = !this.superInventoryItems.length;
      this.isLoading = false;
    },

    async getSaunaProducts() {
      const staticItems = this.saunaStaticItems;

      // Check if all brands are cached
      const allCached = this.menuSaunaBrands.every(
        (brand) => this.categoryCache[brand.treeId],
      );

      if (allCached) {
        this.saunaBrandGroups = this.menuSaunaBrands.map((brand) => ({
          name: brand.name,
          treeId: brand.treeId,
          products: this.categoryCache[brand.treeId] || [],
        }));
        const allProducts = this.saunaBrandGroups.flatMap((g) => g.products);
        this.superInventoryItems = [...staticItems, ...allProducts];
        this.isEmpty = !this.superInventoryItems.length;
        this.isLoading = false;
        return;
      }

      this.isLoading = true;

      try {
        const results = await Promise.all(
          this.menuSaunaBrands.map((brand) =>
            this.categoryCache[brand.treeId]
              ? Promise.resolve({ products: this.categoryCache[brand.treeId] })
              : this.$axios.$get("menu-products", {
                  params: {
                    treeId: brand.treeId,
                    ...(brand.exclude && {
                      exclude: JSON.stringify(brand.exclude),
                    }),
                    ...(brand.includeLinked === false && {
                      includeLinked: "0",
                    }),
                  },
                }),
          ),
        );

        this.saunaBrandGroups = this.menuSaunaBrands.map((brand, index) => {
          const products = (results[index].products || []).map(withModels);
          this.categoryCache[brand.treeId] = products;
          return {
            name: brand.name,
            treeId: brand.treeId,
            products,
          };
        });

        const allProducts = this.saunaBrandGroups.flatMap((g) => g.products);
        this.superInventoryItems = [...staticItems, ...allProducts];
      } catch (err) {
        this.__logError(err);

        this.saunaBrandGroups = [];
        this.superInventoryItems = staticItems;
      }

      this.isEmpty = !this.superInventoryItems.length;
      this.isLoading = false;
    },

    handleCategoryHover(index) {
      if (window.innerWidth >= 1200) {
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }

        this.activeCategory = index;
        this.getProducts(this.categories[index].treeId);
        this.showContent = true;
      }
    },

    handleCategoryLeave() {
      if (window.innerWidth >= 1200) {
        this.hoverTimeout = setTimeout(() => {
          this.showContent = false;
          this.activeCategory = null;
        }, 100);
      }
    },

    handleContentHover() {
      if (window.innerWidth >= 1200) {
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
      }
    },

    handleContentLeave() {
      if (window.innerWidth >= 1200) {
        this.hoverTimeout = setTimeout(() => {
          this.showContent = false;
          this.activeCategory = null;
        }, 100);
      }
    },

    handleMouseEnter(index) {
      if (window.innerWidth < 1200) {
        this.showMobileCategories = true;
        this.$emit("showMobileCategories");
      }

      if (this.activeCategory === index && this.showContent === true) {
        this.showContent = false;
        this.activeCategory = null;
      } else if (this.activeCategory !== index) {
        this.activeCategory = index;
        this.getProducts(this.categories[index].treeId);
        this.showContent = true;
      }
    },

    // Below 1200px a category opens its list in the sidebar rather than its page.
    // Navigating as well closed the sidebar the moment the page loaded, taking
    // the list with it. The list's first entry ("All Saunas", …) is that page.
    handleCategoryClick(event, navigate, index) {
      if (window.innerWidth < 1200) {
        event.preventDefault();
      } else {
        navigate(event);
      }

      this.handleMouseEnter(index);
    },

    handleMouseLeave() {
      if (window.innerWidth < 1200) {
        this.showMobileCategories = false;
        this.$emit("hideMobileCategories");
        this.activeCategory = null;
      }

      this.showContent = false;
    },

    handleClick(index) {
      if (this.activeCategory === index && this.showContent) {
        this.showContent = false;
        this.activeCategory = null;
        return;
      }

      this.activeCategory = index;
      this.showContent = true;
      this.getProducts(this.categories[index].treeId);
    },

    handleNewClick() {
      this.activeCategory = -1;
      this.showContent = false;
    },

    toggleMobileModels(item, event) {
      if (this.expandedModelsId === item.id) {
        this.expandedModelsId = null;
        return;
      }

      this.expandedModelsId = item.id;

      // A row near the bottom of the sidebar (CT Cabin is last) would otherwise
      // open its models out of sight.
      const product = event.currentTarget.closest(
        ".products__navigation_items__product",
      );
      this.$nextTick(() =>
        product.scrollIntoView({ block: "nearest", behavior: "smooth" }),
      );
    },

    // On another page a model link is an ordinary navigation and ProductPage
    // restores the SKU from the fragment when it mounts. On this product already,
    // the page is reused: the router sees at most a hash change, and none at all
    // once syncOfferToHash has rewritten the fragment behind its back, so the
    // click would do nothing. Hand the SKU over directly, and close the menus the
    // route change would have closed.
    handleModelClick(item, model) {
      if (this.$route.path !== this.getProductLink(item)) return;

      this.$root.$emit("product:select-offer", model.sku);

      this.showContent = false;
      this.activeCategory = null;
      this.expandedModelsId = null;
      this.$store.commit("CONFIG/RESET_ALL");
    },

    handleClickOutside(event) {
      if (
        this.$refs.navigationContainer &&
        !this.$refs.navigationContainer.contains(event.target)
      ) {
        this.showContent = false;
        this.activeCategory = null;
      }
    },
  },
  computed: {
    categories() {
      return this.__isOnlineOnlyUser
        ? ONLINE_ONLY_CATEGORIES
        : this.defaultCategories;
    },

    // /menu-products does not check the customer folder, so Online Only
    // customers would be listed Dundalk and Pure Cube saunas that 404 for them.
    menuSaunaBrands() {
      if (!this.__isOnlineOnlyUser) return this.saunaBrands;
      return this.saunaBrands.filter((brand) => brand.treeId === "  652");
    },

    filteredItems() {
      return this.superInventoryItems.filter((item) => {
        return !item.private || (item.private === true && this.__isLoggedIn);
      });
    },

    saunaStaticItems() {
      const hiddenForEuropean = ["  649", "  483"];
      const items = this.categories[0]?.staticSuperInventoryItems || [];
      return items.filter((item) => {
        if (item.europeOnly && !this.__isEuropeanUser) return false;
        if (this.__isEuropeanUser && hiddenForEuropean.includes(item.treeId)) return false;
        return true;
      });
    },
  },
  watch: {
    $route() {
      this.showContent = false;
      this.activeCategory = null;
      this.expandedModelsId = null;
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.showContent = false;
    this.activeCategory = null;
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  },
};
